// Market icons live in `src/assets/images/Perps` and are bundled by webpack, so
// the `/assets/images/Perps/...` paths in `config/markets.js` are logical keys —
// not URLs the browser can request. Everything that renders a market icon has to
// map the key to the bundled asset URL through here.
//
// Stock and commodity icons used to point at raw.githubusercontent.com; GitHub
// rate-limits (429) and serves them with `nosniff`, so the browser blocked them
// and the rows fell back to broken-image glyphs. They're vendored locally now.
const perpsImageContext = require.context(
  '../assets/images/Perps',
  true,
  /\.(png|jpg|jpeg|svg|gif)$/
);

export function resolveMarketIcon(iconPath) {
  if (!iconPath) return null;

  // Remote URLs (CoinGecko and friends) pass straight through.
  if (/^https?:\/\//.test(iconPath)) return iconPath;

  if (iconPath.startsWith('/assets/images/Perps/')) {
    try {
      const filename = iconPath.replace('/assets/images/Perps/', '');
      const asset = perpsImageContext(`./${filename}`);
      // SVGs come back as an ES module — `{ default: url, ReactComponent }` —
      // where PNGs come back as the URL itself. Handed to `<img src>` the module
      // object stringifies to "[object Module]" and renders as a broken image.
      return (asset && asset.default) || asset;
    } catch (e) {
      console.warn(`Failed to load image from ${iconPath}:`, e);
      return null;
    }
  }

  return iconPath;
}
